import { Component,OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebapiService } from '../../../shared/services/webapi.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserInfo } from 'src/app/store/actions/user.action';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-login-dropdown',
  templateUrl: './login-dropdown.component.html',
  styleUrls: ['./login-dropdown.component.scss']
})
export class LoginDropdownComponent implements OnInit {
  formSubmitting=false;
  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(8)]],
  });

  constructor(private fb: FormBuilder,public webApi: WebapiService,private store: Store<AppState>, private toastrService: ToastrService, public router: Router) {}
  ngOnInit() {
  }

  onSubmit(event:any,form: FormGroup) {
    event.preventDefault()
    event.stopPropagation()
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      this.webApi.login(form.value.email,form.value.password).subscribe((data: any) => {
        this.formSubmitting=false;
        if(data.success){
          this.store.dispatch(new UserInfo())
          this.webApi.setLoader(true)
          this.webApi.setSession(data);
          if(data.new_message && data.new_message?.id){
            console.log(data.new_message)
            this.webApi.newMessage = data.new_message
            setTimeout(()=>{
              if(document.getElementById('new-message-modal')){
                var myModal2 = new bootstrap.Modal(document.getElementById('new-message-modal'), {
                  keyboard: true
                })
                myModal2.show()
              }
            },15300)
            //$('#new-message-modal').modal('show');
          }
          if(data.new_videos && data.new_videos.length){
            this.webApi.newVideos = data.new_videos
            setTimeout(()=>{
              if(document.getElementById('new-videos-modal')){
                var myModal = new bootstrap.Modal(document.getElementById('new-videos-modal'), {
                  keyboard: true
                })
                myModal.show()
              }
            },300)
            ///$('#new-videos-modal').modal('show');
          }
          if(data.showdisclaimer){
            setTimeout(()=>{
              if(document.getElementById('disclaimer-modal')){
                var myModal1 = new bootstrap.Modal(document.getElementById('disclaimer-modal'), {
                  keyboard: true
                })
                myModal1.show()
              }
            },30300)
          }
          $('dropdown-menu.login-menu').trigger('click');
          this.router.navigateByUrl('/video');
          this.webApi.setLoader(false)
        }else{
          if(data.olduser && data.olduser==1){
            this.router.navigateByUrl('/forgot-password')
          }
					this.toastrService.error(data.message);
        }
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }

}
